import React from "react";
import colors from "../theme/colors";
import radius from "../theme/radius";
import typography from "../theme/typography";

const sizeStyles = {
  sm: {
    minHeight: 40,
    padding: "0 12px",
    fontSize: typography.size.sm,
  },
  md: {
    minHeight: 46,
    padding: "0 14px",
    fontSize: typography.size.sm,
  },
  lg: {
    minHeight: 52,
    padding: "0 16px",
    fontSize: typography.size.base,
  },
};

export default function Input({
  type = "text",
  size = "md",
  disabled = false,
  invalid = false,
  fullWidth = true,
  style = {},
  className = "",
  ...rest
}) {
  const resolvedSize = sizeStyles[size] || sizeStyles.md;

  return (
    <input
      type={type}
      disabled={disabled}
      className={className}
      style={{
        width: fullWidth ? "100%" : "auto",
        minHeight: resolvedSize.minHeight,
        borderRadius: radius.sm,
        border: `1.5px solid ${invalid ? colors.error : colors.border}`,
        background: disabled ? colors.surfaceSoft : colors.surface,
        padding: resolvedSize.padding,
        fontFamily: typography.fontFamily,
        fontSize: resolvedSize.fontSize,
        fontWeight: typography.weight.medium,
        color: colors.textPrimary,
        outline: "none",
        boxSizing: "border-box",
        transition: "border-color 0.15s ease, box-shadow 0.15s ease, opacity 0.15s ease",
        opacity: disabled ? 0.7 : 1,
        WebkitTapHighlightColor: "transparent",
        ...style,
      }}
      onFocus={(event) => {
        event.currentTarget.style.boxShadow = "0 0 0 3px rgba(106, 74, 166, 0.18)";
        if (rest.onFocus) rest.onFocus(event);
      }}
      onBlur={(event) => {
        event.currentTarget.style.boxShadow = "none";
        if (rest.onBlur) rest.onBlur(event);
      }}
      {...rest}
    />
  );
}